import React from "react";
import styles from "./FranchiseUSP.module.css";

const FranchiseUSP = () => {
  const plans = [
    {
      title: "BASIC",
      details: [
        {
          label: "Investment",
          value:
            "An investment of 8 Lakhs is required to be made available for channel partner Fee, Robotic and Drone Kits and making the Centre Ready.",
        },
        {
          label: "Area Required",
          value:
            "400 – 500 sq.ft Built-up Area, at a good location accessible and visible to customers, for housing the smart className setup.",
        },
        {
          label: "Skills Required",
          value:
            "An entrepreneurial mindset with the evidence of local market knowledge and Strong Marketing and Sales skills.",
        },
        {
          label: "Long Term Vision",
          value:
            "A vision to create an impact in your society with our business and grow a long way in the network along with us.",
        },
      ],
    },
    {
      title: "ADVANCED",
      details: [
        {
          label: "Investment",
          value:
            "An investment of 12 Lakhs is required to be made available for channel partner Fee, Robotic and Drone Kits and making the Centre Ready.",
        },
        {
          label: "Area Required",
          value:
            "900 – 1000 sq.ft Built-up Area, at a good location accessible and visible to customers, for housing the smart className setup.",
        },
        {
          label: "Skills Required",
          value:
            "An entrepreneurial mindset with the evidence of local market knowledge and Strong Marketing and Sales skills.",
        },
        {
          label: "Long Term Vision",
          value:
            "A vision to create an impact in your society with our business and grow a long way in the network along with us.",
        },
      ],
    },
  ];

  // Get all unique labels from both plans
  const labels = plans[0].details.map((detail) => detail.label);

  return (
    <section className={styles.franchiseUSP}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Channel Partner USP</h2>
        <p className={styles.intro} data-aos="fade-up">
          This is a market in which there aren't that many players as of yet, so
          it makes it all the more attractive an industry to enter.
        </p>
        <div className={styles.tableContainer} data-aos="fade-up">
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Requirements</th>
                {plans.map((plan, index) => (
                  <th key={index}>{plan.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {labels.map((label, idx) => (
                <tr key={idx}>
                  <td className={styles.labelColumn}>{label}</td>
                  {plans.map((plan, planIdx) => (
                    <td key={planIdx}>
                      {
                        plan.details.find((detail) => detail.label === label)
                          ?.value
                      }
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default FranchiseUSP;
